// extracted by mini-css-extract-plugin
export var deleteModal = "_hq-0";